<template>
  <section class="container">
    <div class="flex justify-between gap-4 items-center flex-col md:flex-row" :class="parentClass">
      <div class="w-full md:w-1/2 bg-primary-purple-100 rounded-[19px]" :class="borderClass">
        <img v-if="image" :src="image" :class="imageClass" alt="portal-img" class="img-flip" />
        <div v-else class="md:pl-5">
          <div class="flex justify-center items-center overflow-hidden h-full w-full">
            <iframe
              id="video"
              class="cursor-pointer md:w-full rounded-3xl h-60 md:h-84 w-11/12 mb-5 md:mb-0"
              :src="generalConstants.MYQAMPUS_VIDEO"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
        <slot name="image"></slot>
      </div>
      <div class="w-full md:w-1/2" :class="headingClass">
        <div>
          <slot></slot>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import generalConstants from '@src/constants/general-constants.js'
export default {
  props: {
    borderClass: {
      type: String,
      default: '',
    },
    headingClass: {
      type: String,
      default: '',
    },
    containerClass: {
      type: String,
      default: 'mx-auto container xl:px-[100px]',
    },
    parentClass: {
      type: String,
      default: '',
    },
    childClass: {
      type: String,
      default: '2xl:px-0  ',
    },
    childClassContent: {
      type: String,
      default: '',
    },
    imageClass: {
      type: String,
      default: '',
    },
    paragraphAlignment: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      generalConstants,
    }
  },
}
</script>

<style scoped>
.border-color {
  background: transparent linear-gradient(129deg, #ecf3d3 0%, #cbefd4 100%) 0% 0% no-repeat
    padding-box;
}
/* width */
::-webkit-scrollbar {
  width: 12px;
}
/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 9px;
  background: var(--primary-purple-50);
}

/* thumb  */
::-webkit-scrollbar-thumb {
  width: 8px;
  height: 12px;
  max-height: 20px;
  border: 2px solid transparent;
  border-radius: 9px;
  background-color: white;
  background-clip: content-box;
  overflow-y: auto;
}
::-webkit-scrollbar-thumb:hover {
  background-color: var(--primary-purple-100);
}
</style>
